import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import FileCopyOutlined from '@material-ui/icons/FileCopyOutlined';
import LinkOutlined from '@material-ui/icons/LinkOutlined';
import * as React from 'react';
import { toast } from 'react-toastify';
import { CHECKOUT_SUN_URL } from 'settings';
import Truncate from 'v2/components/Shared/TruncateText';

import type { ProductOffer } from 'v2/interfaces/product';

import { useStyles } from './styles';

type PricesListProps = {
  offer: ProductOffer;
};

type ProductPrice = ProductOffer['prices'][0];

function PricesList({ offer }: PricesListProps) {
  const classes = useStyles();

  function mountOfferLink(price: ProductPrice) {
    return `${CHECKOUT_SUN_URL}/${offer.key}?currency=${price.currency.code}`;
  }

  function copyLinkToClipboard(link: string) {
    navigator.clipboard.writeText(link);
    toast.success('Link copiado para a área de transferência');
  }

  function mountOfferCurrency(price: ProductPrice) {
    return `${price.currency.code} (${price.currency.name})`;
  }

  if (!offer.prices?.length) return null;

  return (
    <TableContainer>
      <Table size='small'>
        <TableHead>
          <TableCell>Moeda</TableCell>
          <TableCell width={112}>Valor</TableCell>
          <TableCell width={300}>Página de pagamento (Checkout Sun)</TableCell>
        </TableHead>
        <TableBody>
          {offer.prices.map((price) => (
            <TableRow key={price.id}>
              <TableCell
                style={{
                  whiteSpace: 'nowrap',
                }}
                id={`links-modal-offer-currency-${price.currency.code}`}
              >
                <Truncate count={25}>{mountOfferCurrency(price)}</Truncate>
              </TableCell>
              <TableCell id={`links-modal-offer-price-${price.currency.code}`}>
                {price.value.toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: price.currency.code,
                })}
              </TableCell>
              <TableCell style={{ paddingRight: 0 }}>
                <div className={classes.checkoutLinkContainer}>
                  <LinkOutlined style={{ fontSize: 18 }} />
                  <a id={`links-modal-offer-link-${price.currency.code}`} href={mountOfferLink(price)} target='_blank' rel='noreferrer'>
                    {mountOfferLink(price)}
                  </a>
                  <IconButton
                    id={`links-modal-copy-button-${price.currency.code}`}
                    size='small'
                    onClick={() => copyLinkToClipboard(mountOfferLink(price))}
                  >
                    <FileCopyOutlined style={{ fontSize: 18 }} />
                  </IconButton>
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export { PricesList };
